import Header from './design/Header';
import { useEffect, useState } from 'react'
import Minting from "./components/Minting"
import Staking from "./components/Staking"
import PhaseTwo from './components/PhaseTwo'
import Links from './components/Links'
import { useQuery } from '@apollo/client'
import { parseGraphObject, QUERY, QUERY_GLOBAL, QUERY_STAKED, QUERY_STAKED_OLD, } from './utils/query'
import Feeding from './components/Feeding';
import { isApproved } from './utils/woolf';
import { getClaimableBarnFfwool, getClaimableFastfood, getClaimablePackFfwool, getFastfoodBalance, getFastfoodBalanceEnoughUntil } from './utils/barn';
import { parseBigNumber, parseBigNumberRaw } from './utils/ethereum';
import { getAllowance } from './utils/erc20';
import { BigNumber, ethers } from 'ethers';
import MigrationModal from './components/MigrationModal';
import WoodButton from './components/WoodButton';
import { getBalanceOfFastfood } from './utils/fastfood';
import useMediaQuery from './hooks/useMediaQuery';
import testTokens from "./testData/tokens";
// import {tokenURI} from "./utils/woolf"

const Page = ({ wallet, chain, wool, reload }) => {
  const bp768px = useMediaQuery(768);
  // const [tokenUris, setTokenUris] = useState({});
  const [tokenUris] = useState({});

  const PLACEHOLDER = "data:application/json;base64,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"

  const enrichSome = (e, totalSupply) => {
    if (Number(e.number) + 10 <= Number(totalSupply)) {
      if (!tokenUris.hasOwnProperty(e.number)) {
        return e;
        //   tokenURI(e.number).then(dat => {
        //     setTokenUris(uris => ({
        //       ...uris,
        //       [e.number]: dat
        //     }))
        //   })
      }

      return {
        ...e,
        alpha: e.hasOwnProperty('alpha') ? e.alpha : null,
        ears: e.hasOwnProperty('ears') ? e.ears : null,
        eyes: e.hasOwnProperty('eyes') ? e.eyes : null,
        feet: e.hasOwnProperty('feet') ? e.feet : null,
        fur: e.hasOwnProperty('fur') ? e.fur : null,
        head: e.hasOwnProperty('head') ? e.head : null,
        isSheep: e.hasOwnProperty('isSheep') ? e.isSheep : true,
        mouth: e.hasOwnProperty('mouth') ? e.mouth : null,
        neck: e.hasOwnProperty('neck') ? e.neck : null,
        nose: e.hasOwnProperty('nose') ? e.nose : null,
        tokenURI: tokenUris.hasOwnProperty(e.number) ? tokenUris[e.number] : PLACEHOLDER
      }
    } else {
      return e;
    }
  }

  const [unstakedPageSize, setUnstakedPageSize] = useState(100);
  const [unstakedOffset, setUnstakedOffset] = useState(0);
  const [unstakedCount, setUnstakedCount] = useState(0);

  const [mintCount, setMintCount] = useState("0");

  const [windowSizeChanged, setWindowSizeChanged] = useState(false);

  const [unstaked, setUnstaked] = useState([]);

  const { data, loading, refetch } = useQuery(
    QUERY,
    {
      variables: {
        wallet: wallet || '',
        first: unstakedPageSize,
        skip: unstakedOffset
      },
    }
  );
  const { data: dataStaked, loading: loadingStaked, refetch: refetchStaked } = useQuery(
    QUERY_STAKED,
    {
      variables: {
        wallet: wallet || ''
      },
    }
  );
  const { data: dataOld, loading: loadingOld, refetch: refetchOld } = useQuery(
    QUERY_STAKED_OLD,
    {
      variables: {
        wallet: wallet || ''
      },
    }
  );
  const { data: dataGlobal, refetch: refetchGlobal } = useQuery(
    QUERY_GLOBAL,
    {
      variables: {
        wallet: wallet || '',
      },
      pollInterval: 2500,
    }
  );

  const changeUnstakedPage = (newPage) => setUnstakedOffset(newPage * unstakedPageSize - unstakedPageSize);

  const placeholderCount = (i, offset, pageSize, tokensCount) => {
    if (tokensCount > 0)
      return (
        offset / pageSize + 1 === Math.ceil(tokensCount / pageSize)
          ? i < tokensCount - (Math.ceil(tokensCount / pageSize) - 1) * pageSize
          : i < pageSize
      );
    else return false;
  }

  const updateUnstaked = () => {
    setUnstaked(
      bp768px
        ? testTokens.filter((t, i) => placeholderCount(i, unstakedOffset, unstakedPageSize, unstakedCount))
        : unstaked.concat(testTokens.filter((t, i) => placeholderCount(i, unstakedOffset, unstakedPageSize, unstakedCount))));
  }

  useEffect(() => {
    updateUnstaked();
  }, [unstakedOffset]);

  useEffect(() => {
    if (bp768px) {
      if (unstakedOffset === 0) updateUnstaked();
      else setUnstakedOffset(0);
    }
  }, [unstakedPageSize]);

  const [dataGlobalSet, setDataGlobalSet] = useState(false);

  useEffect(() => {
    if (dataGlobal) setDataGlobalSet(true);
  }, [dataGlobal]);

  useEffect(() => {
    if (data && dataGlobalSet) {
      const newTokens = [...data.tokens.map(x => parseGraphObject(x))].map(e => enrichSome(e, dataGlobal.stat.totalSupply));
      setUnstaked(
        bp768px
          ? newTokens
          : unstaked.filter(t => !t.id.includes('T'))
            .concat(newTokens.filter(t1 => !unstaked.find(t2 => t2.id === t1.id))));

      // add value walletMintedCount if matches wallet and exists
      if (data.user && data.user.length) {
        if (wallet !== null) {
          const adjustedWallet = wallet.toLowerCase().trim();
          if (adjustedWallet === data.user[0].id.toLowerCase().trim()) {
            const newUnstakedCount = parseInt(data.user[0].tokenCount);
            if (newUnstakedCount > unstakedCount) setUnstakedCount(newUnstakedCount);
            setMintCount(data.user[0].mintCount);
          }
        }
      }
    }
  }, [data, dataGlobalSet]);

  useEffect(() => {
    if (unstaked.length > 0) {
      setWindowSizeChanged(true);
      setUnstaked([]);
    }
  }, [bp768px]);

  useEffect(() => {
    if (windowSizeChanged) {
      setWindowSizeChanged(false);
      setUnstakedPageSize(100);
      setUnstakedOffset(0);
    }
  }, [windowSizeChanged]);

  const reloadLocal = () => {
    refetch();
    refetchStaked();
    refetchGlobal();
    reload();
  }


  let stakes = [];

  if (dataStaked?.newStakes) {
    stakes = [...dataStaked.newStakes.map(x => parseGraphObject(x))].sort((e1, e2) => { return parseInt(e1.id, 16) - parseInt(e2.id, 16) })
  }

  var stakesOld;
  if (dataOld?.stakes) {
    stakesOld = [...dataOld.stakes.map(x => parseGraphObject(x))].sort((e1, e2) => { return parseInt(e1.id, 16) - parseInt(e2.id, 16) })
  }


  const [approvedStaking, setApprovedStaking] = useState(false);
  const [claimableFromBarn, setClaimableFromBarn] = useState();
  const [claimableFromPack, setClaimableFromPack] = useState();
  const [intervalFfwool, setIntervalFfwool] = useState();
  const [intervalIsApproved, setIntervalIsApproved] = useState();

  useEffect(async () => {
    if (wallet) {
      if (intervalIsApproved !== undefined) clearInterval(intervalIsApproved);

      setApprovedStaking(await isApproved(wallet));

      const interval = setInterval(async () => {
        setApprovedStaking(await isApproved(wallet));
      }, 2500);
      setIntervalIsApproved(interval);
      return () => clearInterval(interval);
    }
  }, [wallet]);

  useEffect(() => {
    if (approvedStaking && intervalIsApproved !== undefined) clearInterval(intervalIsApproved);
  }, [approvedStaking]);

  const setClaimableFfwool = async () => {
    setClaimableFromBarn(parseBigNumberRaw(await getClaimableBarnFfwool(wallet)));
    setClaimableFromPack(parseBigNumberRaw(await getClaimablePackFfwool(wallet)));
  }

  useEffect(async () => {
    if (wallet && approvedStaking) {
      if (intervalFfwool !== undefined) clearInterval(intervalFfwool);

      await setClaimableFfwool();

      const interval = setInterval(async () => {
        await setClaimableFfwool();
      }, 2500);
      setIntervalFfwool(interval);
      return () => clearInterval(interval);
    }
  }, [wallet, approvedStaking]);



  const [approvedFastFood, setApprovedFastFood] = useState(false);
  const [allowanceFastfood, setAllowanceFastfood] = useState();
  const [fastFoodInWallet, setFastFoodInWallet] = useState();
  const [fastFood, setFastFood] = useState();
  const [claimableFastFood, setClaimableFastFood] = useState();
  const [depletionTimestamp, setDepletionTimestamp] = useState();
  const [intervalFastFood, setIntervalFastFood] = useState();
  const [intervalDepletion, setIntervalDepletion] = useState();

  useEffect(() => {
    if (wallet) {
      getAndSetAllowance(process.env.REACT_APP_FAST_FOOD, process.env.REACT_APP_BARN_V3, setAllowanceFastfood);
    }
  }, [wallet]);

  const getAndSetAllowance = (token, spender, setter) => {
    getAllowance(token, wallet, spender)
      .then(response => {
        setter(response);
      })
      .catch(err => {
        console.error(err);
      });
  }

  useEffect(() => {
    if (allowanceFastfood && allowanceFastfood.gt(BigNumber.from(0))) setApprovedFastFood(true);
    else setApprovedFastFood(false);
  }, [allowanceFastfood]);

  //itt kéri le a contractól a foodreserve-t és a claimelhető foodmennyiséget
  const setFastFoodStates = async () => {
    setFastFoodInWallet(parseBigNumber(await getBalanceOfFastfood(wallet), 3, "ether"));
    setFastFood(parseBigNumber(await getFastfoodBalance(wallet), 3, "ether"));
    setClaimableFastFood(parseBigNumber(await getClaimableFastfood(wallet), 3, "ether"));
  }

  useEffect(async () => {
    if (wallet && approvedFastFood) {
      if (intervalFastFood !== undefined) clearInterval(intervalFastFood);

      await setFastFoodStates();

      const interval = setInterval(async () => {
        await setFastFoodStates();
      }, 2500);
      setIntervalFastFood(interval);
      return () => clearInterval(interval);
    }
  }, [wallet, approvedFastFood]);

  useEffect(() => {
    if (wallet && approvedFastFood) {
      if (intervalDepletion !== undefined) clearInterval(intervalDepletion);

      const handleSetDepletionTimestamp = async () => {
        const timeStampUntilEnough = await getFastfoodBalanceEnoughUntil(wallet);
        if (timeStampUntilEnough.eq(ethers.constants.MaxUint256)) setDepletionTimestamp(Date.now() / 1000);
        else setDepletionTimestamp((timeStampUntilEnough).toNumber());
      };
      handleSetDepletionTimestamp();

      const interval = setInterval(async () => await handleSetDepletionTimestamp(), 2500);
      setIntervalDepletion(interval);
      return () => clearInterval(interval);
    }
  }, [wallet, approvedFastFood]);


  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="home container mx-auto p-1 sm:p-5">
      <Header />
      <div className="mt-5 mb-5 text-center lg:flex flex-wrap justify-center">
        <a href="/" className="btn-frame">Home</a>
        <a href="/game" className="btn-frame">Restaurants</a>
        <a href="/war" className="btn-frame">War</a>
        <a href="/supergrass" className="btn-frame">Supergrass</a>
        <WoodButton
          title={"MIGRATE TO V2"}
          onClick={() => setModalOpen(true)}
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="col-span-2 xl:col-span-1 mt-5">
          <Feeding
            wallet={wallet} chain={chain}
            approved={approvedFastFood}
            setApproved={setApprovedFastFood}
            getAndSetAllowance={getAndSetAllowance}
            setAllowanceFastfood={setAllowanceFastfood}
            fastFoodInWallet={fastFoodInWallet}
            fastFood={fastFood}
            claimableFastFood={claimableFastFood}
            setFastFoodStates={setFastFoodStates}
            depletionTimestamp={depletionTimestamp}
          />

          <div className="mt-5">
            <Minting
              wallet={wallet}
              chain={chain}
              stats={dataGlobal?.stat}
              reload={reload}
              woolBalance={wool}
              walletMintedCount={mintCount}
            />
          </div>

          <div className="mt-5">
            <PhaseTwo />
          </div>

          <div className="mt-5">
            <Links />
          </div>

          {/* <div className="mt-5">
            <Stats stats={dataGlobal?.stat} />
          </div>

          <div className="mt-5">
            <Leaderboard users={data?.users} />
          </div> */}
        </div>
        <div className="col-span-2 xl:col-span-1 mt-5">
          <Staking
            wallet={wallet}
            chain={chain}
            wool={wool}
            unstaked={unstaked}
            unstakedPageSize={unstakedPageSize}
            setUnstakedPageSize={setUnstakedPageSize}
            unstakedPageCount={Math.ceil(unstakedCount / unstakedPageSize)}
            unstakedPage={unstakedOffset / unstakedPageSize + 1}
            changeUnstakedPage={changeUnstakedPage}
            stakes={stakes}
            stats={dataGlobal?.stat}
            reload={reloadLocal}
            fetching={loading}
            approved={approvedStaking}
            setApproved={setApprovedStaking}
            claimableFromBarn={claimableFromBarn}
            claimableFromPack={claimableFromPack}
          />
        </div>
      </div>
      <br />
      <div className="mt-5 mb-5 text-right">
        <a href="/tos" className="btn-frame btn-small">Terms of Service</a>
      </div>
      <MigrationModal
        wallet={wallet}
        chain={chain}
        modalOpen={modalOpen}
        ids={unstaked?.map(t => t.number)?.concat(stakesOld?.map(s => s.number))}
        approved={approvedStaking}
        setApproved={setApprovedStaking}
        noStaked={stakesOld?.length === 0}
      />
    </div>
  )
}

// <img className="absolute h-full w-full object-cover" src="/images/background.png" alt="" style={{zIndex:-1000}}/>

export default Page
